module.exports = __webpack_public_path__ + "img/DkIuXdQy.1fa9032a.svg";